module.exports = __webpack_public_path__ + "img/材料力学1_1.c7bab5b7.jpg";